<script>
import { Pie, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";
import { inMemoryBotInfo } from "../base";


export default {
  extends: Pie,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await inMemoryBotInfo()
      .then((response) => {
        
        let getGuilds = response.average_server_growth_monthly / 25;
        let averageGuilds = Math.round(getGuilds);

        let getVotes = response.average_votes_growth_monthly / 25;
        let averageVotes = Math.round(getVotes);


        this.chartData = {
          labels: ["New guilds", "New votes"],
          datasets: [
          
            {
              backgroundColor: [getRandomColor(), getRandomColor()],
              data: [averageGuilds, averageVotes]
            }
           
          ],
        };

        this.chartOptions = {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          legend: {
            display: true,
          },
          responsive: true,
          maintainAspectRatio: false,
        };
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>
